var codeblock_default = {
  "blockStyleSpacing": "gjPfd",
  "codeBlock": "IhmzM gjPfd",
  "renderedInTable": "HY93x"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
